<template>
  <div class="dialogCommunication">
    <dialogTitle name="新增记录" />
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="" prop="desc">
        <el-input
          type="textarea"
          v-model="ruleForm.desc"
          placeholder="请输入沟通记录"
        ></el-input>
      </el-form-item>
    </el-form>
    <dialogTitle name="历史记录" />
    <template v-if="logs.length">
      <div class="CommunicationMain">
        <div
          class="CommunicationMainItem"
          v-for="(item, index) in logs"
          :key="index"
        >
          <h3>{{ item.time }}</h3>
          <p>
            {{ item.note }}
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="CommunicationMain"><h3>暂无</h3></div>
    </template>
    <div class="CommunicationFooter">
      <el-button type="primary" @click="submitForm('ruleForm')"
        >提交记录</el-button
      >
    </div>
  </div>
</template>

<script>
import dialogTitle from "./dialogtitle";
import {
  gongshangwriteCommunicationLog,
  gongshangqueryExpertApplyCommunicationLogs,
} from "@/api/alicp";
import moment from "moment";
export default {
  props: ["channelNeedNo"],
  data() {
    return {
      ruleForm: {
        desc: "",
      },
      rules: {
        desc: [
          {
            required: true,
            message: "请输入沟通记录",
            trigger: "blur",
          },
        ],
      },
      logs: [],
    };
  },
  components: {
    dialogTitle,
  },
  mounted() {
    this.queryExpertApplyCommunicationLogs();
  },
  methods: {
    //获取沟通记录
    queryExpertApplyCommunicationLogs() {
      let obj = {
        intentionBizId: this.channelNeedNo,
        BeginTime: "",
        EndTime: "",
        PageNum: "1",
        PageSize: "100",
      };
      gongshangqueryExpertApplyCommunicationLogs(obj).then((res) => {
        console.log(res);
        if (res.status == 0) {
          this.logs = [];
          res.data.data.data.infos.map((item) => {
            console.log("item++++++++", item);
            this.logs.push({
              ...item,
              time: moment(item.createTime * 1000).format(
                "YYYY-MM-DD HH:mm:ss"
              ),
              note: item.note,
            });
          });
        }
      });
    },
    //提交沟通记录
    submitForm(formName) {
      let obj = {
        intentionBizId: this.channelNeedNo,
        note: this.ruleForm.desc,
      };
      this.$refs[formName].validate((valid) => {
        console.log(obj, "valid");
        if (valid) {
          this.$emit("tolkParent", { loading: true, dialog: true });
          gongshangwriteCommunicationLog(obj).then((res) => {
            console.log(res, "resresres");
            if (res.status == 0) {
              this.$message({
                message: "提交记录成功！",
                type: "success",
              });
              this.$emit("tolkParent", {
                loading: false,
                dialog: false,
              });
              this.ruleForm.desc = "";
              this.queryExpertApplyCommunicationLogs();
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
              this.$emit("tolkParent", {
                loading: false,
                dialog: true,
              });
            }
          });
        } else {
          this.$message({
            message: "请输入沟通记录",
            type: "warning",
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.dialogCommunication {
  width: 100%;
  max-height: 700px;
  overflow: auto;
  .el-form {
    width: 100%;
    .el-form-item {
      .el-form-item__content {
        margin-left: 50px !important;
        .el-textarea__inner {
          height: 200px;
          width: 550px;
        }
      }
    }
  }
  .CommunicationMain {
    width: 100%;
    padding: 0 50px;
    padding-bottom: 10px;
    .CommunicationMainItem {
      margin-bottom: 20px;
      h3 {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(38, 38, 38, 0.6);
        line-height: 22px;
        letter-spacing: 1px;
        margin-bottom: 10px;
      }
      p {
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(38, 38, 38, 1);
        line-height: 22px;
        letter-spacing: 1px;
      }
    }
  }
  .CommunicationFooter {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-button {
      background: #ff8a01;
      border: none;
    }
  }
}
</style>
